import { styled } from '#core/gen/jsx';

export const Text = styled('p');
